import { UserGuideHeader } from 'components/new_components/AppUserGuide';

export const steps = [
    {
        title: <UserGuideHeader title="Create Users" />,
        description: 'Add users to your account for an efficient compliance process.',
        placement: 'bottomRight',
    },
];
